/**
 * @module FE-CU59_ライセンス画面
 */
import TermView from '../../components/termView/TermView.vue';
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU59';

export default {
  name: 'PrivacyPolicy',
  components: {
    TermView,
    Header,
    BreadCrumbList,
    PcPageTitle,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.ライセンス.ライセンス'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU59ライセンス.C0001'),
      htmlContent: '',
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.ライセンス.ライセンス'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU59ライセンス.C0001'),
      };
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.loadHtml(localStorage.getItem('lang'));
  },
  /** @type {Methods} */
  methods: {
    /**
     * html埋め込み処理
     * @param {*} lang 言語
     */
    loadHtml(lang) {
      var htmlPath = '';
      htmlPath =
        lang === 'ja'
          ? window.location.origin + '/hs-static/license-jpn.html'
          : window.location.origin + '/hs-static/license-eng.html';

      fetch(htmlPath).then((res) => {
        res.text().then((html) => {
          this.htmlContent = html;
        });
      });
    },
    /**
     * 言語切り替えボタン押下時処理
     */
    changeLang(lang) {
      this.loadHtml(lang);
    },
  },
};
